export const voiceCallStatuses = {
    ringing: {
        key: 'ringing',
        message: 'Chamando...',
        isCallProgress: true,
    },
    conecting: {
        key: 'conecting',
        message: 'Conectando...',
        isCallProgress: true,
    },
    inCall: {
        key: 'inCall',
        message: 'Em chamada',
        isCallProgress: true,
    },
    finishing: {
        key: 'finishing',
        message: 'Finalizando chamada...',
        isCallProgress: true,
    },
    finished: {
        key: 'finished',
        message: 'Chamada finalizada',
    },
    error: {
        key: 'error',
        message: 'Erro ao realizar chamada!',
    },
    reconnecting: {
        key: 'reconnecting',
        message: 'Reconectando...',
        isCallProgress: true,
    },
}

export const voiceCallOutcomeOptions = [
    { key: 'answered', label: 'Atendeu' },
    { key: 'no_answer', label: 'Não atendeu' },
    { key: 'voicemail', label: 'Caixa postal' },
]

export const voiceCallConclusionSource = 'voip';